import { useEffect, useRef, useState } from 'react'
import { LoomVideoButton } from './LoomVideoButton'
import { withTooltipWrapper } from './TooltipWrapper'
import { ConditionalWrapper } from './ConditionalWrapper'
import { useLoomContext } from './LoomContext'
import { loomRecordButtonStates, loomSdkStates } from '../../../config/app-specific-config/loom-constants';

import '../../digital-sales-room/styles/loom.scss';
import { Box } from '@chakra-ui/react'
import { TbBrandZoom } from 'react-icons/tb'

export const DsrLoomRecordButton = ({  submitRecording, handleCreateNewPost, handleSaveVideoToSubWidget, handleSaveVideoToOverviewPage, displayClassName }) => {
  const recordButtonRef = useRef()
  const [highlight, setHighlight] = useState(false)
  const DEFAULT_BUTTON_TEXT = loomRecordButtonStates.record

  const {configureButton, sdkState, initialized, isLoomSupported} = useLoomContext()
  const [buttonText, setButtonText] = useState(sdkState)


  useEffect(() => {
    if (!initialized) return
    if (!isLoomSupported) return

    void applyConfig()
  }, [initialized, isLoomSupported])

  useEffect(() => {
    sdkState !== loomSdkStates.loaded ? setButtonText(sdkState) : setButtonText(DEFAULT_BUTTON_TEXT)
  }, [sdkState])

  const applyConfig = async () => {
    const loomButton = configureButton?.({ element: recordButtonRef.current })

    const onRecStart = () => setButtonText(loomRecordButtonStates.recording)
    const onCancel = () => setButtonText(DEFAULT_BUTTON_TEXT)
    const onRecComplete = () => setButtonText(loomRecordButtonStates.uploading)
    const onUploadComplete = async (video) => {
      await submitRecording(video) // this video SHOULD have a thumbnail
      setButtonText(DEFAULT_BUTTON_TEXT)
    }
    const onInsertClick = (video) => {
      if(!video) return

      if (!!handleSaveVideoToSubWidget) {
        handleSaveVideoToSubWidget([video])
      }

      if (!!handleCreateNewPost) {
        const videoCreateData = {
          userActionRequired: "create-video-post",
          inputValue: "",
          postType: "loom-video-post",
          loomVideo: video,
        }
        handleCreateNewPost(videoCreateData)
      }
 
      if (!!handleSaveVideoToOverviewPage) {
        handleSaveVideoToOverviewPage("loomWelcomeVideo", {loomWelcomeVideo: video})
      }
    }
    buttonConfig({loomButton, onRecStart, onCancel,  onRecComplete, onUploadComplete, onInsertClick })
  }

  const buttonConfig = ({loomButton, onRecStart, onCancel, onRecComplete, onUploadComplete, onInsertClick}) => {
    loomButton.on('recording-start', onRecStart)
    loomButton.on('cancel', onCancel)
    loomButton.on('recording-complete', onRecComplete)
    loomButton.on('upload-complete', onUploadComplete)
    loomButton.on("insert-click", onInsertClick)
  }

  useEffect(() => {
    return () => {
      if (!configureButton) return
      configureButton({ element: null })
    }
  }, [])

  if (displayClassName==="create-post-button") {
    return (
      <>
        <ConditionalWrapper condition={buttonText === loomSdkStates.recordingNotSupported} wrapper={withTooltipWrapper}>
          <Box 
            p='0.5em 1em'
            rounded='0.5em'
            onMouseOver={()=>setHighlight(true)}
            onMouseLeave={()=>setHighlight(false)}
            bg={highlight && "brand.50"}
            // border='1px solid'
            // borderColor={highlight ? "brand.200" : "white"}
            transition= 'all 0.2s ease-in-out'
            >

          <LoomVideoButton
            label={buttonText}
            ref={recordButtonRef}
            disabled={buttonText === loomSdkStates.recordingNotSupported}
            mode={"create-post-button"}
            className={displayClassName}
            icon={TbBrandZoom}
          />
          </Box>
        </ConditionalWrapper>
      </>
    )
  }

  else {
    return (
      <>
        <ConditionalWrapper condition={buttonText === loomSdkStates.recordingNotSupported} wrapper={withTooltipWrapper}>
          <LoomVideoButton
            label={buttonText}
            ref={recordButtonRef}
            disabled={buttonText === loomSdkStates.recordingNotSupported}
          />
        </ConditionalWrapper>
      </>
    )
  }
}
